<template>
  <v-data-table
    :headers="headers"
    mobile-breakpoint="0"
    :items-per-page="5"
    :items="items"
    item-key="id"
    loading-text="Đang Tải"
    disable-sort
    no-data-text="Không tìm thấy dữ liệu"
  >
    <template v-slot:[`item.sumFees`]="{ item }">
      <div v-if="item.sumFees.length === 0">Không có khoản lương nào</div>
      <div v-else>
        <div v-for="(i, idx) in item.sumFees" :key="item.id + '_sum_' + idx">
          <div class="d-flex align-center" style="min-height: 30px">
            <div style="width: 300px; margin-right: 20px">{{ i.name }}</div>
            <div>{{ i.value.toLocaleString('en-US') }}</div>
          </div>
          <v-divider />
        </div>
      </div>
    </template>
    <template v-slot:[`item.minusFees`]="{ item }">
      <div v-if="item.minusFees.length === 0">Không có khoản trừ nào</div>
      <div v-else>
        <div v-for="(i, idx) in item.minusFees" :key="item.id + '_mis_' + idx">
          <div class="d-flex align-center" style="min-height: 30px">
            <div style="width: 300px; margin-right: 20px; min-height: 30px">{{ i.name }}</div>
            <div>{{ i.value.toLocaleString('en-US') }}</div>
          </div>
          <v-divider />
        </div>
      </div>
    </template>
    <template v-slot:[`item.taxFees`]="{ item }">
      <div v-if="item.taxFees.length === 0">Không có khoản điều chỉnh nào</div>
      <div v-else>
        <div v-for="(i, idx) in item.taxFees" :key="item.id + '_tax_' + idx">
          <div class="d-flex align-center" style="min-height: 30px">
            <div style="width: 300px; margin-right: 20px; min-height: 30px">{{ i.name }}</div>
            <div>{{ i.value.toLocaleString('en-US') }}</div>
          </div>
          <v-divider />
        </div>
      </div>
    </template>
    <template v-slot:[`item.totalBeforeTax`]="{ item }">
      {{ item.totalBeforeTax.toLocaleString('en-US') }}
    </template>
    <template v-slot:[`item.totalTax`]="{ item }">
      <div class="red--text">
        {{ item.totalTax.toLocaleString('en-US') }}
      </div>
    </template>
    <template v-slot:[`item.totalAfterTax`]="{ item }">
      {{ item.totalAfterTax.toLocaleString('en-US') }}
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: { items: Array },
  computed: {
    headers() {
      return [
        { text: 'Mã giáo viên', value: 'code', width: '110px' },
        { text: 'Tên giáo viên', value: 'name', width: '150px' },
        { text: 'Các khoản lương', value: 'sumFees', width: '400px' },
        { text: 'Các khoản trừ', value: 'minusFees', width: '400px' },
        { text: 'Các điều chỉnh lương', value: 'taxFees', width: '400px' },
        { text: 'Tổng thu nhập', value: 'totalBeforeTax' },
        { text: 'Thuế', value: 'totalTax' },
        { text: 'Thu nhập sau thuế', value: 'totalAfterTax' },
      ]
    },
  },
}
</script>
